import { DirectiveOptions } from 'vue';

const FullNumberTooltip: DirectiveOptions = {
  bind(el, binding) {
    setHandlers(el, binding.value);
  },
  update(el, binding) {
    // Если значение поменялось — пересоздаём обработчики с новым текстом
    if (binding.value !== binding.oldValue) {
      removeHandlers(el);
      setHandlers(el, binding.value);
    }
  },
  unbind(el) {
    removeHandlers(el);
  },
};

function setHandlers(el: HTMLElement, value: any) {
  let tooltip: HTMLDivElement | null = null;
  let handlerAdded = false;

  function showTooltip(event: MouseEvent) {
    if (tooltip) return;
    tooltip = document.createElement('div');
    tooltip.textContent = String(value ?? '');
    tooltip.style.position = 'fixed';
    tooltip.style.zIndex = '9999';
    tooltip.style.background = '#fff';
    tooltip.style.border = '1px solid #ccc';
    tooltip.style.padding = '6px 12px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.boxShadow = '0 2px 8px rgba(0,0,0,0.15)';
    tooltip.style.fontFamily = 'monospace';
    tooltip.style.fontSize = '14px';
    tooltip.style.whiteSpace = 'pre';
    tooltip.style.left = event.clientX + 10 + 'px';
    tooltip.style.top = event.clientY + 10 + 'px';
    document.body.appendChild(tooltip);

    setTimeout(() => {
      const range = document.createRange();
      range.selectNodeContents(tooltip!);
      const sel = window.getSelection();
      sel?.removeAllRanges();
      sel?.addRange(range);
    }, 0);

    setTimeout(() => {
      if (!handlerAdded) {
        document.addEventListener('mousedown', hideTooltip, { once: true });
        handlerAdded = true;
      }
    }, 0);
  }

  function hideTooltip() {
    tooltip?.remove();
    tooltip = null;
    if (handlerAdded) {
      document.removeEventListener('mousedown', hideTooltip);
      handlerAdded = false;
    }
  }

  el.addEventListener('mouseenter', showTooltip);
  el.addEventListener('mousemove', (e) => {
    if (tooltip) {
      tooltip.style.left = e.clientX + 10 + 'px';
      tooltip.style.top = e.clientY + 10 + 'px';
    }
  });
  el.addEventListener('mouseleave', hideTooltip);

  (el as any).__fullNumberTooltip__ = { showTooltip, hideTooltip };
}

function removeHandlers(el: HTMLElement) {
  const handlers = (el as any).__fullNumberTooltip__;
  if (handlers) {
    el.removeEventListener('mouseenter', handlers.showTooltip);
    el.removeEventListener('mouseleave', handlers.hideTooltip);
    handlers.hideTooltip();
    delete (el as any).__fullNumberTooltip__;
  }
}

export default FullNumberTooltip;
